import React from 'react'
import { Box } from '@mui/material'
import ResizeGrip from './ResizeGrip'

/**
 * SurfaceResizeHandle.jsx — story 215 (RN3, RN8, R4, R5).
 * The bar under the graph and under the Tree that sets their height. Same gesture as the Mixed split of the
 * library panel: it follows the mouse at once, and the listeners live on `window`, so the drag ends wherever
 * the button is released (E1).
 */
export const SURFACE_INITIAL_HEIGHT = '50vh'
const HANDLE_PX = 10

const SurfaceResizeHandle = ({ height, surfaceRef, onHeightChange }) => {
  const startResize = (event) => {
    // No text selection and no node drag start here (R4).
    event.preventDefault()
    event.stopPropagation()
    const startY = event.clientY
    // Until the first drag the height is "50vh": the start is what the surface measures on screen.
    const startHeight = typeof height === 'number' ? height : surfaceRef.current.getBoundingClientRect().height
    const move = (moveEvent) => onHeightChange(Math.max(0, Math.round(startHeight + moveEvent.clientY - startY)))
    const stop = () => {
      window.removeEventListener('mousemove', move)
      window.removeEventListener('mouseup', stop)
    }
    window.addEventListener('mousemove', move)
    window.addEventListener('mouseup', stop)
  }

  return (
    <Box
      data-testid='surface-resize-handle'
      role='separator'
      aria-orientation='horizontal'
      onMouseDown={startResize}
      sx={{
        height: HANDLE_PX,
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'row-resize',
        bgcolor: 'divider',
        '&:hover': { bgcolor: 'primary.main' },
        '&:hover > *': { borderColor: 'primary.contrastText' }
      }}
    >
      <ResizeGrip />
    </Box>
  )
}

export default SurfaceResizeHandle
